<template>
  <div>
    <div v-if="reveal" style="padding-bottom:0.35rem;">
      <span class="us_block_title">按设备标签统计</span>
      <div v-if="loading" style="margin-top:1rem;">
        <LoadingText />
      </div>
      <div style="background:#fff;" v-else>
          <div v-if="statsData.labels.length > 0" :id="id" :class="className" style="margin:auto;" :style="{height:height,width:width}" />
          <div v-else :class="className" :style="{ height: height, width: width, lineHeight:height }" style="text-align:center;color:#9e9e9e;font-size:0.8rem;">暂无数据</div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import LoadingText from '../../components/LoadingText'
export default {
  components: { LoadingText },
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    id: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '250px'
    }
  },
  data() {
    return {
      chart: null,
      statsData: {
        labels: [],
        values: []
      },
      loading: true,
      reveal: false,
      tagTotal: 0
    }
  },
  watch: {
  },
  activated() {
    this.getDeviceTagsStats()
    this.windowSize()
  },
  deactivated() {
    window.onresize = null
  },
  mounted() {
    this.getDeviceTagsStats()
    this.windowSize()
  },
  beforeDestroy() {
    window.onresize = null
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      var that = this
      if (that.statsData.labels.length <= 0) {
        that.reveal = false
        return
      }
      if (that.tagTotal < 10) {
        that.reveal = false
        return
      }
      that.reveal = true
      this.$nextTick(function() {
        this.drawPieGraph()
      })
    },
    // 获取设备系统标签统计
    async getDeviceTagsStats() {
      var that = this
      var res = await that.$api.iot.statsDeviceSystemTags()
      // console.log('statsDeviceTags.res', res)
      if (!res.success) {
        console.log('获取设备常用标签统计失败', res)
        that.loading = false
        return
      }
      var data = res.data
      // that.statsData = data
      var labels = []
      var values = []
      that.tagTotal = 0
      for (let index = 0; index < data.length; index++) {
        const item = data[index]
        labels.push(item.tag_text)
        values.push({ name: item.tag_text, value: item.count })
        that.tagTotal += item.count
      }
      that.statsData = {
        labels: labels,
        values: values
      }
      that.loading = false
      this.$nextTick(function() {
        that.initChart()
      })

    },
    // 画饼
    drawPieGraph() {
      var that = this
      if (that.chart) {
        that.chart.dispose()// 销毁
      }
      that.chart = echarts.init(document.getElementById(that.id))
      // var option = {
      //   tooltip: {
      //     trigger: 'item'
      //     // formatter: '{a} <br/>{b} : {c}'
      //   },
      //   legend: {
      //     // orient: 'vertical',
      //     type: 'scroll',
      //     data: that.statsData.labels,
      //     textStyle: {
      //       color: '#808080'
      //     },
      //     top: '90%',
      //     left: 'center'
      //   },
      //   series: [
      //     {
      //       name: '数量',
      //       type: 'pie',
      //       radius: '40%',
      //       top: '-30%',
      //       center: ['50%', '60%'],
      //       data: that.statsData.values,
      //       itemStyle: {
      //         emphasis: {
      //           shadowBlur: 10,
      //           shadowOffsetX: 0,
      //           shadowColor: 'rgba(0, 0, 0, 0.5)'
      //         }
      //       },
      //       // roseType: 'radius',
      //       label: {
      //         normal: {
      //           // {c}
      //           formatter: '{b}：{c}'
      //           // 标签文字在内部
      //           // position: 'inner'
      //         }
      //       },
      //       animationType: 'scale',
      //       animationEasing: 'elasticOut'
      //     }
      //   ]
      // }

      // var option = {
      //   tooltip: {
      //     trigger: 'item'
      //   },
      //   legend: {
      //     type: 'scroll',
      //     data: that.statsData.labels,
      //     textStyle: {
      //       color: '#808080'
      //     },
      //     top: '90%',
      //     left: 'center'
      //   },
      //   series: [
      //     {
      //       name: '数量',
      //       type: 'pie',
      //       radius: ['65%', '80%'],
      //       center: ['50%', '45%'],
      //       avoidLabelOverlap: false,
      //       data: that.statsData.values,
      //       label: {
      //         show: false,
      //         position: 'center'
      //       },
      //       emphasis: {
      //         label: {
      //           show: true,
      //           fontSize: '14',
      //           fontWeight: 'bold'
      //         }
      //       },
      //       labelLine: {
      //         show: false
      //       }
      //     }
      //   ]
      // }

      var option = {
        tooltip: {
          trigger: 'item'
        },
        // legend: {
        //   type: 'scroll',
        //   data: that.statsData.labels,
        //   textStyle: {
        //     color: '#808080'
        //   },
        //   top: '90%',
        //   left: 'center'
        // },
        // 设置环形中间的数据
        // graphic: [{
        //   type: 'text',
        //   left: 'center',
        //   top: '42%',
        //   z: 10,
        //   style: {
        //     fill: '#777777',
        //     text: '总数：' + that.tagTotal,
        //     fontSize: '20px',
        //     fontWeight: 'bold'
        //   }
        // }],
        series: [
          {
            name: '数量',
            type: 'pie',
            radius: ['45%', '60%'],
            center: ['50%', '45%'],
            avoidLabelOverlap: false,
            data: that.statsData.values,
            label: {
              // show: false,
              // position: 'center'
              position: 'outer',
              formatter: '{a_set|{b}}: {c_set|{c}}',
              rich: {
                a_set: {
                  fontSize: '14px',
                  color: '#1a1a1a',
                  lineHeight: 20,
                  align: 'center'
                },
                c_set: {
                  fontSize: '14px',
                  color: '#808080'
                }

              }
            },
            emphasis: {
              // label: {
              //   show: true,
              //   fontSize: '14',
              //   fontWeight: 'bold'
              // }
            },
            labelLine: {
              // show: false
            }
          }
        ]
      }
      that.chart.clear()
      that.chart.setOption(option)
      that.chart.resize()
    },
    windowSize() {
      var that = this
      // 监听窗口大小
      window.onresize = () => {
        return (() => {
          if (that.id && document.getElementById(that.id)) {
            if (that.chart) {
              that.chart.resize()
            }
          }
        })()
      }
    }
  }
}
</script>
<style scoped>
.us_block_title{
  font-weight:bold;
  font-size:1.05rem;
  color: rgba(33,33,33,0.9);
}
</style>
